/* Old World New Art — shared theme JS */
(function () {
  // Update header cart count badge from /cart.js
  window.ownaRefreshCart = function () {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = '(' + cart.item_count + ')';
        });
        return cart;
      })
      .catch(function () {});
  };

  document.addEventListener('click', function (e) {
    // Accordion toggles
    var acc = e.target.closest('.acc-head');
    if (acc) { acc.parentElement.classList.toggle('open'); }

    // Mobile menu toggle
    var burger = e.target.closest('.burger');
    if (burger) {
      var menu = document.querySelector('.menu');
      if (menu) menu.classList.toggle('is-open');
    }
  });

  document.addEventListener('DOMContentLoaded', function () { window.ownaRefreshCart(); });
})();
